import classNames from 'classnames';
import { useIntl } from 'react-intl';

type DlpRealtimeFooterProps = {
  underlyingValue: number | null;
  underlyingUnit: string | null;
  lastUpdate: Date | null;
  className?: string;
};

export function DlpRealtimeFooter({ underlyingUnit, underlyingValue, className, lastUpdate }: DlpRealtimeFooterProps) {
  const { formatTime, formatNumber } = useIntl();

  return (
    <div className={classNames('d-flex justify-content-end align-items-center', className)}>
      {underlyingValue !== null && underlyingUnit !== null && (
        <div className="badge badge-primary rounded-pill px-3 mx-2 ">
          Underlying: {formatNumber(underlyingValue)} {underlyingUnit}
        </div>
      )}
      {lastUpdate !== null && (
        <span className="fs-12">last update: {formatTime(lastUpdate, { timeStyle: 'medium' })}</span>
      )}
    </div>
  );
}
